module.exports.OrganizationMap = {
    "nautica2": "Nautica",
    "rivera_isles": "Rivera Isles",
    "carillon_club": "Carillon Club",
    "seaside": "Seaside",
    "disney-contino": "Contino",
    "legacyClubCabo": "Legacy Club",
    "destinyByTheSea": "Destiny by the Sea"
}

module.exports.OrganizationNameMap = {
    "nautica2": "Nautica",
    "seaside": "Seaside",
    "disney-contino": "Contino",
    "legacyClubCabo": "Legacy Club",
    "destinyByTheSea": "Destiny by the Sea"
}

module.exports.OrganizationConfig = {
    namingMap: this.OrganizationNameMap,
    colorMap: {
        colorPrimary: "#699991"
    }
}

module.exports.RoleNameMap = {
    "admin": "Admin",
    "hoa_admin": "HOA Admin",
    "property_manager": "Property Manager",
    "guard": "Guard",
    "resident": "Resident",
    "secondary_user": "Secondary User",
    "ct_admin": "CT Admin"
}